import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import React from 'react';

const TableHeader = ({ title, action }) => {
  return (
    <Stack
      mb={1.5}
      direction="row"
      justifyContent="space-between"
      spacing={2}
      alignItems="center"
      sx={{ px: 1.5 }}
    >
      <Typography variant="h5" fontWeight={600}>
        {title}
      </Typography>
      {action}
    </Stack>
  );
};

export default TableHeader;
